import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { getDomDistance, getQuery } from '@src/utils/index';
import smoothscroll from 'smoothscroll-polyfill';
import { area } from '@src/utils/area';

smoothscroll.polyfill();

const Banner = ({ languages, setLanguagesHandle }) => {
    const imgRef = useRef();
    const bannerImgUrl = area[languages].banner.post;
    const info = area[languages].banner.info;
    const infoText = area[languages].banner.infoText;
    const demand = area?.[languages]?.banner?.demand;
    const demandText = area?.[languages]?.banner?.demandText;

    useEffect(() => {
        const bannerImgObj = new Image();

        bannerImgObj.onload = () => {
            const fromWecom = getQuery(location.href, 'from_wecom');
            const domPageTop = getDomDistance(imgRef.current).top;

            if (domPageTop && fromWecom === '1') {
                window.scroll({ top: domPageTop, behavior: 'smooth' });
            }
        };

        bannerImgObj.src = bannerImgUrl;
    }, []);

    return (
        <div className={styles.banner}>
            <div className={styles.languagesSelect}>
                <span
                    className={`${styles.languagesTtem} ${languages === 'zh' ? styles.current : ''}`}
                    onClick={() => {
                        setLanguagesHandle('zh');
                    }}>
                    繁
                </span>
                <span className={styles.languagesSelectLine} />
                <span
                    className={`${styles.languagesTtem} ${languages === 'en' ? styles.current : ''}`}
                    onClick={() => {
                        setLanguagesHandle('en');
                    }}>
                    EN
                </span>
                <span className={styles.languagesSelectLine} />
                <span
                    className={`${styles.languagesTtem} ${languages === 'ch' ? styles.current : ''}`}
                    onClick={() => {
                        setLanguagesHandle('ch');
                    }}>
                    简
                </span>
            </div>
            <img src={bannerImgUrl} className={styles.banner1} />
            <div className={styles.bref}>
                <img ref={imgRef} src={info} className={styles.brefPic} />
                <div className={styles.brefText}>{infoText}</div>
            </div>
            {demand && (
                <div className={styles.demand}>
                    <img src={demand} className={styles.brefPic} />
                    <div className={styles.brefText}>{demandText}</div>
                </div>
            )}
        </div>
    );
};

Banner.propTypes = {
    languages: PropTypes.string,
    setLanguagesHandle: PropTypes.func,
};

export default errorBoundary(Banner);
